(ns quuppa.qsm.ui-state.events
  (:require [re-frame.core :as rf]))

(rf/reg-event-db ::update
  (fn [db [_ page-key f & args]]
    (apply update-in db [:ui-state page-key] f args)))

(rf/reg-event-db ::update-in
  (fn [db [_ path f & args]]
    (apply update-in db (concat [:ui-state] path) f args)))

(rf/reg-event-db ::assoc-in
  (fn [db [_ path value]]
    (assoc-in db (cons :ui-state path) value)))

(rf/reg-event-db ::init-new-site-plan-form
  (fn [db _]
    (assoc-in db [:ui-state :site :sidebar :new-site-plan-form :data]
              {:starting-point :floorplan
               :site-type :industrial
               :locator-type :Q17})))

(rf/reg-event-fx ::set-sidebar-type
  ;; will clear whole :sidebar datastructure
  (fn [{:keys [db]} [_ page-key sidebar-type]]
    (merge
      {:db (assoc-in db [:ui-state page-key :sidebar] {:type sidebar-type})}
      (when (= sidebar-type :create-site-plan)
        {:fx [[:dispatch [::init-new-site-plan-form]]]}))))

(rf/reg-event-db ::init-sidebar-form
  (fn [db [_ page-key form-key init-data]]
    (assoc-in db [:ui-state page-key :sidebar form-key] init-data)))

(rf/reg-event-db ::set-sidebar-form-field
  (fn [db [_ page-key form-key field value]]
    (assoc-in db [:ui-state page-key :sidebar form-key :data field] value)))

(rf/reg-event-db ::close-sidebar
  (fn [db [_ page-key]]
    (assert page-key "Missing page key for ::close-sidebar")
    (update-in db [:ui-state page-key] dissoc :sidebar)))
